export const EMAIL_PATTERN = /\S+@\S+\.\S+/;
export const URL_PATTERN =
    /[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)/;
export const URL_PARAMS_PATTERN = /:\w+/;
